"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var isEmail_1 = require("./isEmail");
exports.isEmail = isEmail_1.default;
var ReactMultiEmail_1 = require("./ReactMultiEmail");
exports.ReactMultiEmail = ReactMultiEmail_1.default;



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-multi-email/commonjs/index.js
// module id = 1315
// module chunks = 9